const ALLOWED_ORIGINS_REGEX = /^https:\/\/(([a-z0-9-]+)\.)?manage\.wix\.com$/;

export const isWixOrigin = (origin: string) =>
  ALLOWED_ORIGINS_REGEX.test(origin);
